import { NgFor, NgIf } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RightNavItem } from "../../../models/rightnav";

@Component({
  selector: "app-right-nav",
  templateUrl: "./right-nav.component.html",
  styleUrls: ["./right-nav.component.scss"],
  standalone: true,
  imports: [NgIf, NgFor],
})
export class RightNavComponent implements OnInit {
  @Input() webinarUrl?: string;
  @Input() showContact: boolean = false;
  @Input() items!: RightNavItem[];
  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigate(item: RightNavItem) {
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.fragment = item.id;
    this.router.navigateByUrl(urlTree);
  }

  get _items(): RightNavItem[] {
    return Array.from(document.querySelectorAll(".card"))
      .filter((card) => card.getAttribute("data-sidenav-label"))
      .map((card) => ({
        id: card.getAttribute("id") || "",
        label: card.getAttribute("data-sidenav-label")?.valueOf() || "",
      }));
  }
}
